/**
 * OTA Update Configuration
 * Hardcoded configuration for OTA updates system
 */

export const OTA_UPDATE_CONFIG = {
  // Enable or disable OTA updates globally
  enabled: true,
  
  // Update check interval in seconds (default: 24 hours)
  checkInterval: 24 * 60 * 60,
  
  // Minimum app version required for OTA updates
  minAppVersion: '0.115.0',
  
  // Force users to update before using the app
  forceUpdate: false,
} as const;

// Helper functions to access config values
export function isOTAUpdatesEnabled(): boolean {
  return OTA_UPDATE_CONFIG.enabled;
}

export function getOTAUpdateCheckInterval(): number {
  return OTA_UPDATE_CONFIG.checkInterval;
}

export function getMinAppVersionForUpdate(): string {
  return OTA_UPDATE_CONFIG.minAppVersion;
}

export function isForceUpdateEnabled(): boolean {
  return OTA_UPDATE_CONFIG.forceUpdate;
}
